import compose from 'recompose/compose';
import Google from "./google";

export default compose(Google)